module.exports = __webpack_public_path__ + "img/kv-mob.9ccf7666.png";